import { BCMSAsset } from "@bcm-dev/bcms-vite";

//SVG Imports
import AirplaneIcon from "res/img/AirplaneIcon.svg?react";
import AlertIcon from "res/img/AlertIcon.svg?react";
import BagIcon from "res/img/BagIcon.svg?react";
import CalendarIcon from "res/img/CalendarIcon.svg?react";
import CallIcon from "res/img/CallIcon.svg?react";
import OutlineCardIcon from "res/img/CardDetailsIcon.svg?react";
import CardIcon from "res/img/CardIcon.svg?react";
import CardFreeCashIcon from "res/img/CardfreeCashIcon.svg?react";
import CardOutlineIcon from "res/img/CardOutlineIcon.svg?react";
import CheckingAccountIcon from "res/img/CheckingAccountIcon.svg?react";
import CheckmarkBadgeIcon from "res/img/CheckmarkBadgeIcon.svg?react";
import CheckmarkCircleIcon from "res/img/CheckmarkCircleIcon.svg?react";
import CheckmarkIcon from "res/img/CheckmarkIcon.svg?react";
import CircleMinusIcon from "res/img/CircleMinusIcon.svg?react";
import CirclePlusIcon from "res/img/CirclePlusIcon.svg?react";
import ClockIcon from "res/img/ClockIcon.svg?react";
import DocumentsAlertIcon from "res/img/DocumentsAlertIcon.svg?react";
import DollarHandIcon from "res/img/DollarHandIcon.svg?react";
import DollarMoneyBagIcon from "res/img/DollarMoneyBagIcon.svg?react";
import DownChevronIcon from "res/img/DownChevronIcon.svg?react";
import EnvelopeIcon from "res/img/EnvelopeIcon.svg?react";
import FilledCardIcon from "res/img/FilledCardIcon.svg?react";
import FlagIcon from "res/img/FlagIcon.svg?react";
import GearIcon from "res/img/GearIcon.svg?react";
import GiftIcon from "res/img/GiftIcon.svg?react";
import InformationIcon from "res/img/InformationIcon.svg?react";
import LeftChevronIcon from "res/img/LeftChevronIcon.svg?react";
import LockIcon from "res/img/LockIcon.svg?react";
import MagnifyingGlassIcon from "res/img/MagnifyingGlassIcon.svg?react";
import MapLocationIcon from "res/img/MapLocationIcon.svg?react";
import MeterLimitsIcon from "res/img/MeterLimitsIcon.svg?react";
import MinusIcon from "res/img/MinusIcon.svg?react";
import MoneyDocumentIcon from "res/img/MoneyDocumentIcon.svg?react";
import MoneyLightBulbIcon from "res/img/MoneyLightBulbIcon.svg?react";
import MoneyRefreshIcon from "res/img/MoneyRefreshIcon.svg?react";
import MonthCalendarIcon from "res/img/MonthCalendarIcon.svg?react";
import NotebookPencilIcon from "res/img/NotebookPencilIcon.svg?react";
import ReplaceCardIcon from "res/img/OutlineCardIcon.svg?react";
import OutsideLinkIcon from "res/img/OutsideLinkIcon.svg?react";
import PencilIcon from "res/img/PencilIcon.svg?react";
import PersonGearIcon from "res/img/PersonGearIcon.svg?react";
import PhoneIcon from "res/img/PhoneIcon.svg?react";
import PhoneSignalIcon from "res/img/PhoneSignalIcon.svg?react";
import PinIcon from "res/img/PinIcon.svg?react";
import PlusIcon from "res/img/PlusIcon.svg?react";
import QuestionMarkCircleIcon from "res/img/QuestionMarkCircleIcon.svg?react";
import RefreshIcon from "res/img/RefreshIcon.svg?react";
import RightChevronIcon from "res/img/RightChevronIcon.svg?react";
import SentCardIcon from "res/img/SentCardIcon.svg?react";
import SentNewCardIcon from "res/img/SentNewCardIcon.svg?react";
import ShopIcon from "res/img/ShopIcon.svg?react";
import ShoppingCartIcon from "res/img/ShoppingCartIcon.svg?react";
import SwitchAddIcon from "res/img/SwitchAddIcon.svg?react";
import TagIcon from "res/img/TagIcon.svg?react";
import TicketIcon from "res/img/TicketIcon.svg?react";
import TwoHalfArrowsIcon from "res/img/TwoHalfArrowsIcon.svg?react";
import UpChevronIcon from "res/img/UpChevronIcon.svg?react";
import VerticalDotsIcon from "res/img/VerticalDotsIcon.svg?react";
import WalletSignalIcon from "res/img/WalletSignalIcon.svg?react";
import XCircleIcon from "res/img/XCircleIcon.svg?react";
import XIcon from "res/img/XIcon.svg?react";

// IMG Imports
import CardImage from "res/img/228817.png";
import BargainBasket from "res/img/BargainBasket.png";
import BigBoxInc from "res/img/BigBoxInc.png";
import CaffeinatorCafe from "res/img/CaffeinatorCafe.png";
import CineplexTheater from "res/img/CineplexTheater.png";
import CrispysChicken from "res/img/CrispysChicken.png";
import DrugRx from "res/img/DrugRx.png";
import SilverwareIcon from "res/img/EatingIcon.png";
import CameraIcon from "res/img/EntertainmentIcon.png";
import FareDeals from "res/img/FareDeals.png";
import FlyFree from "res/img/FlyFree.png";
import FuelStop from "res/img/FuelStop.png";
import GasPumpIcon from "res/img/GasPumpIcon.png";
import GiveGood from "res/img/GiveGood.png";
import GoogleWalletAsset from "res/img/GoogleWalletAsset.png";
import GroceryBagIcon from "res/img/GroceryIcon.png";
import HailRepair from "res/img/HailRepair.png";
import HappyPaws from "res/img/HappyPaws.png";
import HeartPlusIcon from "res/img/HealthcareIcon.png";
import HomeStore from "res/img/HomeStore.png";
import InstaGrub from "res/img/InstaGrub.png";
import MoviesNow from "res/img/MoviesNow.png";
import EllipsisIcon from "res/img/OtherIcon.png";
import EZRider from "res/img/EZRider.png";
import PillowInn from "res/img/PillowInn.png";
import PizzaTown from "res/img/PizzaTown.png";
import SampleStatementImage from "res/img/SampleStatement.png";
import ShoppingBagIcon from "res/img/ShoppingBagIcon.png";
import TheChronicle from "res/img/TheChronicle.png";
import WhiteFlagIcon from "res/img/WhiteFlagIcon.png";
import WholesomeFoods from "res/img/WholesomeFoods.png";
import ABCWaterWorksLogo from "res/img/abcWaterworks.png";
import AddACardImage from "res/img/addACard.png";
import AmericanEnergyLogo from "res/img/americanEnergyLogo.png";
import ApplePayIcon from "res/img/applePay.png";
import AppleWalletIcon from "res/img/appleWallet.png";
import AustraliaFlagIcon from "res/img/australiaFlag.png";
import BlueCardBGImage from "res/img/blueBG.png";
import GrayCardBGImage from "res/img/cardBackroundGray.png";
import CardCheckmarkIcon from "res/img/cardCheckmark.png";
import BlueGradientCardBGImage from "res/img/cardGradient.png";
import GrayGradientCardBGImage from "res/img/creditCardBackground.png";
import CardDetailsImage from "res/img/creditCardDetails.jpg";
import CreditCardLogo from "res/img/creditCardLogo.png";
import CreditDetailsImage from "res/img/creditDetails.png";
import CreditNoDetailsImage from "res/img/creditNoDetails.png";
import DebitDetailsImage from "res/img/debitDetails.png";
import DebitNoDetailsImage from "res/img/debitNoDetails.png";
import FederalElectricLogo from "res/img/federalElectric.png";
import GasIcon from "res/img/gasIcon.png";
import GermanyFlagIcon from "res/img/germanyFlag.png";
import GreenCardBGImage from "res/img/greenBG.png";
import HorizontalCardIcon from "res/img/horizontaCard.png";
import IndiaFlagIcon from "res/img/indiaFlag.png";
import LifeInsuranceLogo from "res/img/lifeInsuranceSpiraLogo.png";
import LoadIcon from "res/img/load.png";
import LocationImage from "res/img/location1.png";
import MapLocationImage from "res/img/mapLocation1.png";
import MapPlaceholderImage from "res/img/mapPlaceholder.png";
import MaroonGaugeLogo from "res/img/maroonGauge.png";
import MastercardLogo from "res/img/mc.png";
import MobileUltraLogo from "res/img/mobileUltra.png";
import MortgageLogo from "res/img/mortgageLogo.png";
import MyFinancialLogo from "res/img/myFinancialLogo.png";
import WhiteMyFinancialLogo from "res/img/myFinancialLogo740x200.png";
import MySpendIcon from "res/img/mySpend.png";
import NationalCreditGraphIcon from "res/img/nationalCreditGraph.png";
import OtherCreditIcon from "res/img/otherCredit.png";
import PayPalLogo from "res/img/paypal.png";
import PersonIcon from "res/img/person.png";
import PlugInIcon from "res/img/plugIn.png";
import SampleStatementImageFiserv from "res/img/sampleStatementFiserv.png";
import SuperFinancialLogo from "res/img/superFinancialGrey.png";
import TelecomSquareLogo from "res/img/telecomSquare.png";
import TwoDiceIcon from "res/img/twoDice.png";
import UnitedStatesFlagIcon from "res/img/unitedStatesFlag.png";
import VerticalCardIcon from "res/img/verticalCard.png";
import VisaLogo from "res/img/visa.png";
import VizcloudLogo from "res/img/vizcloud.png";
import WhatGraphImage from "res/img/whatGraph.png";
import WhenGraphImage from "res/img/whenGraph.png";
import ZoomedInMapImage from "res/img/zoomedInMapImage.png";

const { image, svg } = BCMSAsset.init({
  //SVG Exports
  "AirplaneIcon": AirplaneIcon,
  "AlertIcon": AlertIcon,
  "BagIcon": BagIcon,
  "CalendarIcon": CalendarIcon,
  "CallIcon": CallIcon,
  "CardIcon": CardIcon,
  "CardFreeCashIcon": CardFreeCashIcon,
  "CardOutlineIcon": CardOutlineIcon,
  "CheckingAccountIcon": CheckingAccountIcon,
  "CheckmarkBadgeIcon": CheckmarkBadgeIcon,
  "CheckmarkCircleIcon": CheckmarkCircleIcon,
  "CheckmarkIcon": CheckmarkIcon,
  "CircleMinusIcon": CircleMinusIcon,
  "CirclePlusIcon": CirclePlusIcon,
  "ClockIcon": ClockIcon,
  "DocumentsAlertIcon": DocumentsAlertIcon,
  "DollarMoneyBagIcon": DollarMoneyBagIcon,
  "DollarHandIcon": DollarHandIcon,
  "DownChevronIcon": DownChevronIcon,
  "EnvelopeIcon": EnvelopeIcon,
  "FilledCardIcon": FilledCardIcon,
  "FlagIcon": FlagIcon,
  "GearIcon": GearIcon,
  "GiftIcon": GiftIcon,
  "InformationIcon": InformationIcon,
  "LeftChevronIcon": LeftChevronIcon,
  "LockIcon": LockIcon,
  "MagnifyingGlassIcon": MagnifyingGlassIcon,
  "MapLocationIcon": MapLocationIcon,
  "MeterLimitsIcon": MeterLimitsIcon,
  "MinusIcon": MinusIcon,
  "MoneyDocumentIcon": MoneyDocumentIcon,
  "MoneyLightBulbIcon": MoneyLightBulbIcon,
  "MoneyRefreshIcon": MoneyRefreshIcon,
  "MonthCalendarIcon": MonthCalendarIcon,
  "NotebookPencilIcon": NotebookPencilIcon,
  "OutlineCardIcon": OutlineCardIcon,
  "OutsideLinkIcon": OutsideLinkIcon,
  "PencilIcon": PencilIcon,
  "PersonGearIcon": PersonGearIcon,
  "PhoneIcon": PhoneIcon,
  "PhoneSignalIcon": PhoneSignalIcon,
  "PinIcon": PinIcon,
  "PlusIcon": PlusIcon,
  "QuestionMarkCircleIcon": QuestionMarkCircleIcon,
  "RefreshIcon": RefreshIcon,
  "ReplaceCardIcon": ReplaceCardIcon,
  "RightChevronIcon": RightChevronIcon,
  "SentCardIcon": SentCardIcon,
  "SentNewCardIcon": SentNewCardIcon,
  "ShopIcon": ShopIcon,
  "ShoppingCartIcon": ShoppingCartIcon,
  "SwitchAddIcon": SwitchAddIcon,
  "TagIcon": TagIcon,
  "TicketIcon": TicketIcon,
  "TwoHalfArrowsIcon": TwoHalfArrowsIcon,
  "UpChevronIcon": UpChevronIcon,
  "VerticalDotsIcon": VerticalDotsIcon,
  "WalletSignalIcon": WalletSignalIcon,
  "XCircleIcon": XCircleIcon,
  "XIcon": XIcon,

  //IMG Exports
  "ABCWaterWorksLogo": ABCWaterWorksLogo,
  "AddACardImage": AddACardImage,
  "AmericanEnergyLogo": AmericanEnergyLogo,
  "ApplePayIcon": ApplePayIcon,
  "AppleWalletIcon": AppleWalletIcon,
  "AustraliaFlagIcon": AustraliaFlagIcon,
  "BargainBasket": BargainBasket,
  "BigBoxInc": BigBoxInc,
  "BlueCardBGImage": BlueCardBGImage,
  "BlueGradientCardBGImage": BlueGradientCardBGImage,
  "CaffeinatorCafe": CaffeinatorCafe,
  "CameraIcon": CameraIcon,
  "CardCheckmarkIcon": CardCheckmarkIcon,
  "CardDetailsImage": CardDetailsImage,
  "CardImage": CardImage,
  "CineplexTheater": CineplexTheater,
  "CreditCardLogo": CreditCardLogo,
  "CreditDetailsImage": CreditDetailsImage,
  "CreditNoDetailsImage": CreditNoDetailsImage,
  "CrispysChicken": CrispysChicken,
  "DebitDetailsImage": DebitDetailsImage,
  "DebitNoDetailsImage": DebitNoDetailsImage,
  "DrugRx": DrugRx,
  "EllipsisIcon": EllipsisIcon,
  "EZRider": EZRider,
  "FareDeals": FareDeals,
  "FederalElectricLogo": FederalElectricLogo,
  "FlyFree": FlyFree,
  "FuelStop": FuelStop,
  "GasIcon": GasIcon,
  "GasPumpIcon": GasPumpIcon,
  "GermanyFlagIcon": GermanyFlagIcon,
  "GiveGood": GiveGood,
  "GoogleWalletAsset": GoogleWalletAsset,
  "GrayCardBGImage": GrayCardBGImage,
  "GrayGradientCardBGImage": GrayGradientCardBGImage,
  "GreenCardBGImage": GreenCardBGImage,
  "GroceryBagIcon": GroceryBagIcon,
  "HailRepair": HailRepair,
  "HappyPaws": HappyPaws,
  "HeartPlusIcon": HeartPlusIcon,
  "HomeStore": HomeStore,
  "HorizontalCardIcon": HorizontalCardIcon,
  "IndiaFlagIcon": IndiaFlagIcon,
  "InstaGrub": InstaGrub,
  "LifeInsuranceLogo": LifeInsuranceLogo,
  "LoadIcon": LoadIcon,
  "LocationImage": LocationImage,
  "MapLocationImage": MapLocationImage,
  "MapPlaceholderImage": MapPlaceholderImage,
  "MaroonGaugeLogo": MaroonGaugeLogo,
  "MastercardLogo": MastercardLogo,
  "MobileUltraLogo": MobileUltraLogo,
  "MortgageLogo": MortgageLogo,
  "MoviesNow": MoviesNow,
  "MyFinancialLogo": MyFinancialLogo,
  "MySpendIcon": MySpendIcon,
  "NationalCreditGraphIcon": NationalCreditGraphIcon,
  "OtherCreditIcon": OtherCreditIcon,
  "PayPalLogo": PayPalLogo,
  "PersonIcon": PersonIcon,
  "PillowInn": PillowInn,
  "PizzaTown": PizzaTown,
  "PlugInIcon": PlugInIcon,
  "SampleStatementImage": SampleStatementImage,
  "SampleStatementImageFiserv": SampleStatementImageFiserv,
  "ShoppingBagIcon": ShoppingBagIcon,
  "SilverwareIcon": SilverwareIcon,
  "SuperFinancialLogo": SuperFinancialLogo,
  "TelecomSquareLogo": TelecomSquareLogo,
  "TheChronicle": TheChronicle,
  "TwoDiceIcon": TwoDiceIcon,
  "UnitedStatesFlagIcon": UnitedStatesFlagIcon,
  "VerticalCardIcon": VerticalCardIcon,
  "VisaLogo": VisaLogo,
  "VizcloudLogo": VizcloudLogo,
  "WhatGraphImage": WhatGraphImage,
  "WhenGraphImage": WhenGraphImage,
  "WhiteFlagIcon": WhiteFlagIcon,
  "WhiteMyFinancialLogo": WhiteMyFinancialLogo,
  "WholesomeFoods": WholesomeFoods,
  "ZoomedInMapImage": ZoomedInMapImage,

}).loadAsset();

//Export a function for images
export function ImageAsset(props){
  return (<> { image(props.id, props) }</>);
}

// Export a function for svgs
export function SVGAsset(props){ 
	return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>); 
}
